import { LogoType } from "../../../../commons/types/logo";
import { useCommonAppDispatcher } from "../../store/hooks";

import LogoPartial from "./LogoPartial";

interface Props {
  invert?: boolean;
}

const AppLogoPartial = ({ invert = false }: Props) => {
  const [dispatch, actions] = useCommonAppDispatcher();

  return (
    <LogoPartial
      type={invert ? LogoType.BcIconInvert : LogoType.BcIcon}
      onClick={() => dispatch(actions.modal.showModal("about"))}
    />
  );
};

export default AppLogoPartial;
